import { useLocalObservable } from "mobx-react";
import React, { createContext, ReactNode } from "react";
import PatientsStore from "./patientsStore";
import { PatientsApi } from "../../api-client";
import { AuthContext } from "../Auth/auth.provider";
import useStore from "../../helpers/useStore";
import { UserContext } from "../User/User.provider";
import { createApiConfig } from "../../api/createApiConfig";
import { useSearchParamProjection } from "../../helpers/searchParams/useSearchParamProjection";

interface PatientsProviderProps {
  children: ReactNode;
}

export const PatientsContext = createContext<PatientsStore | null>(null);
PatientsContext.displayName = "PatientsContext";

export const PatientsProvider = ({ children }: PatientsProviderProps) => {
  const AuthenticationStore = useStore(AuthContext);
  const userStore = useStore(UserContext); // Use UserContext

  const apiClient = new PatientsApi(createApiConfig());

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const store = useLocalObservable(() => new PatientsStore(apiClient, userStore, AuthenticationStore));

  store.apiClient = apiClient;

  // Project patient-related navigation state into URL (MobX is source of truth)
  useSearchParamProjection(store, PatientsStore, {
    elideDefaults: true,
    replaceHistory: true,
    debounceMs: 120,
    restrictToBase: true,
    navigateToBase: false,
  });

  return (
    <PatientsContext.Provider value={store}>
      {children} 
    </PatientsContext.Provider>
  );
};
